"use client";

import { type TabItem } from "@kyan/ui";
import { useEffect } from "react";

import { Sidebar as SidebarComponent } from "#/components/Sidebar/Sidebar";
import { routes } from "#/config/routes";
import { usePositionsDrawerSettings } from "#/store/app/positionsDrawer/positionsDrawerSettings";

const tabs: TabItem[] = [
  {
    id: routes.rewards.index,
    label: "Rewards Hub",
  },
  {
    id: routes.rewards.leaderboard,
    label: "Leaderboard",
  },
];

export const Sidebar = () => {
  const { setPositionsDrawerSettings } = usePositionsDrawerSettings();

  useEffect(() => {
    setPositionsDrawerSettings({ show: false });
  }, [setPositionsDrawerSettings]);

  return <SidebarComponent items={tabs} />;
};
